import AjaxPlugin from 'vux/src/plugins/ajax/index.js'


export default {

parklotList: ( data ) => AjaxPlugin.$http.post( `/api/parklot/wx/parklot/list`, data ),

channelList: ( data ) => AjaxPlugin.$http.post( `/api/wx/parklot/channel/list`, data ),

unlicensedCarInOut: ( data ) => AjaxPlugin.$http.post( `/api/parklot/wx/parklot/inoutparklot/opengate`, data ),

queryParklot: ( data ) => AjaxPlugin.$http.post( `/api/wx/parklot/parklot/queryparklot`, data ),

noPlatenumPay: ( data ) => AjaxPlugin.$http.post( `/api/parklot/order/orderpay/noplatenumpay`, data ),

getChanelInfo: ( data ) => AjaxPlugin.$http.get( `/api/parklot/wx/parklot/inoutparklot/getChanelInfo?parklotId=${ data.parklotId }&openId=${ data.openId }&channelId=${ data.channelId }&scanType=${ data.scanType }` ),

noPlateOutQuerycharge: ( data ) => AjaxPlugin.$http.post( `/api/parklot/wx/temporarycarcharge/querycharge`, data ),

listParklots: ( data ) => AjaxPlugin.$http.post( `/apiInvoice/parklot/parkingfeeserial/listParklots`, data )
};



// WEBPACK FOOTER //
// ./src/api/unlicensedCarOutIn.js